<template>
  <div class="container">
    <p>
      在文章详情里下方有学术论坛按钮，点击可跳转到学术论坛平台进行注册账号，通过文献求助获取相关文献，同时学术论坛旨在打造读者和作者之间、作者和作者之间进行学术交流的平台，加强相互之间学术交流，促进合作，推动学术创新和发展，增强作者个人的学术影响力。读者可以向作者提出文献请求互助需求，作者可以向读者传递自己的文献，作者可以上传管理自己发表的，并可以提出一些研究话题和其他作者或读者进行学术讨论交流。
    </p>
    <img src="../../assets/images/newhelp/help17.png" alt="" />
    <img src="../../assets/images/newhelp/help18.png" alt="" />
    <p>
      进入学术论坛后，自动将文献内容填写到学术论坛，提交文献求助，提交后，可在学术论坛——话题——我的提问中，查看相关文献，同时获取成功后可在注册邮箱中有消息提醒。
    </p>
    <img src="../../assets/images/newhelp/help19.png" alt="" />
    <img src="../../assets/images/newhelp/help20.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
